import { StationSource } from './../../../core/models/station-source';
import { Component, Inject, OnInit } from '@angular/core';
import { StationManagementService } from '../../station-management.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-custom-source-dialog',
  templateUrl: './custom-source-dialog.component.html',
  styleUrls: ['./custom-source-dialog.component.scss']
})
export class CustomSourceDialogComponent implements OnInit {
  stationSourceList: StationSource[] = [];
  sourceSelected: StationSource;

  constructor(public dialogRef: MatDialogRef<CustomSourceDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any,
              private readonly stationManagementService: StationManagementService) { }

  ngOnInit() {
    this.stationSourceList = this.data.stationSources;
  }

  addCustomSource() {
    this.dialogRef.close(this.sourceSelected);
  }

}
